export default "__VITE_ASSET__COivxQ5___"